/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { StatutApprenantGridDto } from './StatutApprenantGridDto';
import {
    StatutApprenantGridDtoFromJSON,
    StatutApprenantGridDtoFromJSONTyped,
    StatutApprenantGridDtoToJSON,
} from './StatutApprenantGridDto';

/**
 * 
 * @export
 * @interface StatutApprenantGridDtoPaginatedResults
 */
export interface StatutApprenantGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof StatutApprenantGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StatutApprenantGridDto>}
     * @memberof StatutApprenantGridDtoPaginatedResults
     */
    results?: Array<StatutApprenantGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof StatutApprenantGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the StatutApprenantGridDtoPaginatedResults interface.
 */
export function instanceOfStatutApprenantGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatutApprenantGridDtoPaginatedResultsFromJSON(json: any): StatutApprenantGridDtoPaginatedResults {
    return StatutApprenantGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function StatutApprenantGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatutApprenantGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(StatutApprenantGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function StatutApprenantGridDtoPaginatedResultsToJSON(value?: StatutApprenantGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(StatutApprenantGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

